import { ObjectsListScreen } from '../../objects-list-screen/ObjectsListScreen';
import type { ObjectListScreenEntity } from '../../objects-list-screen/ObjectsListScreen.entity';
import type { TRenderScreen, TSettingsScreenOptions } from '../SettingsScreenRendererService';

export function renderObjectsListScreen(
  screen: ObjectListScreenEntity,
  options: TSettingsScreenOptions,
): TRenderScreen {
  return () => <ObjectsListScreen stack={options.stack} screen={screen} />;
}
